import Link from "@mui/material/Link";
import { Link as RouterLink } from "react-router-dom";

const ColumnsCte = (t) => [
  {
    field: "accesskey",
    headerName: t("columns.accessKey"),
    width: 340,
    cellClassName: "col-chave",
    renderCell: (params) => (
      <Link
        component={RouterLink}
        to={`/inbound/historic/${params.value}`}
        state={{ docType: "cte" }}
      >
        {params.value}
      </Link>
    ),
  },
  { field: "number_cte", headerName: t("columns.cteNumber"), width: 100 },
  { field: "serie", headerName: t("columns.series"), width: 80 },
  {
    field: "carrier_cnpj",
    headerName: t("columns.carrierCnpj"),
    width: 170,
    renderCell: (params) => {
      const value = params.row?.carrier_cnpj;
      if (!value) return "";
      const digits = String(value).replace(/\D/g, "");
      if (digits.length !== 14) return value;
      return digits.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, "$1.$2.$3/$4-$5");
    },
  },
  { field: "carrier_name", headerName: t("columns.carrierName"), width: 220 },
  {
    field: "shipper_cnpj",
    headerName: t("columns.supplierCnpj"),
    width: 170,
    renderCell: (params) => {
      const value = params.row?.shipper_cnpj;
      if (!value) return "";
      const digits = String(value).replace(/\D/g, "");
      if (digits.length !== 14) return value;
      return digits.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, "$1.$2.$3/$4-$5");
    },
  },
  { field: "shipper_name", headerName: t("columns.supplierName"), width: 220 },
  {
    field: "recipient_cnpj",
    headerName: t("columns.destCnpj"),
    width: 170,
    renderCell: (params) => {
      const value = params.row?.recipient_cnpj;
      if (!value) return "";
      const digits = String(value).replace(/\D/g, "");
      if (digits.length !== 14) return value;
      return digits.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, "$1.$2.$3/$4-$5");
    },
  },
  { field: "recipient_name", headerName: t("columns.destName"), width: 220 },
  { field: "cfop", headerName: t("columns.cfop"), width: 90 },
  { field: "nat_op", headerName: t("columns.natOp"), width: 260 },
  { field: "modal", headerName: t("columns.modal"), width: 80 },
  {
    field: "issue_date",
    headerName: t("columns.issueDate"),
    width: 130,
    renderCell: (params) => {
      const value = params.row?.issue_date;
      if (!value) return "";
      return String(value).substring(0, 10).split("-").reverse().join("/");
    },
  },
  {
    field: "issue_time",
    headerName: t("columns.issueTime"),
    width: 115,
    renderCell: (params) => {
      const value = params.row?.issue_time;
      if (!value) return "";
      return String(value).substring(11, 19);
    },
  },
  { field: "uf_ini", headerName: t("columns.ufOrigin"), width: 105 },
  { field: "uf_fim", headerName: t("columns.ufDest"), width: 105 },
  {
    field: "v_tprest",
    headerName: t("columns.totalValue"),
    width: 140,
    type: "number",
    renderCell: (params) => {
      const value = Number(params.row?.v_tprest ?? 0);
      return value.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
    },
  },
  { field: "rntrc", headerName: t("columns.rntrc"), width: 110 },
  { field: "status_sefaz", headerName: t("columns.sefazStatus"), width: 100 },
  { field: "motivo_sefaz", headerName: t("columns.sefazEvent"), width: 220 },
  { field: "log_sefaz", headerName: t("columns.sefazLog"), width: 200 },
];

export default ColumnsCte;
